<template>
  <v-app>
    <v-container fluid>
      <v-row
        align="start"
        align-content="start"
        class="mx-sm-4 mx-0"
        dense
        justify="start"
      >
        <v-col
          class="mb-5 px-3 mt-2"
          cols="12"
        >
          <v-layout
            :style="`height: 60px;background-color: ${backgroundColor}`"
            align-center
            class="ma-0 pa-0"
            d-flex
            justify-start
          >
            <div
              :style="`width:5px; height:100%;background-color:${accentColor}`"
              class="mr-4"
            />
            <div style="font-weight: bold;font-size: 18px;">
              小説一覧
            </div>
            <v-spacer />
            <v-menu
              v-model="sortDialog"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-y
              rounded="0"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="px-3 py-5 mr-4"
                  color="secondary"
                  elevation="0"
                  small
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-img
                    class="mr-3 "
                    contain
                    height="22px"
                    src="../assets/sort.png"
                    width="22px"
                  />
                  並び替え
                </v-btn>
              </template>
              <SortTypeSelect
                :callback="selectSort"
                :items="sortItems"
                :sort-type="sortType"
              />
            </v-menu>
            <v-btn
              class="px-3 py-5 mr-4"
              color="secondary"
              elevation="0"
              small
              tile
              @click="filterMenu = true"
            >
              <div style="position: relative;">
                <v-icon size="30">
                  mdi-menu
                </v-icon>
                <v-img
                  width="16px"
                  src="../assets/settei.png"
                  style="position: absolute;right:-8px;top:-3px;"
                />
              </div>
            </v-btn>
          </v-layout>
        </v-col>
        <v-list-item>
          <v-spacer />
          <div>
            <v-btn
              class="text-button-small ma-0 pa-0  ml-auto"
              text
              small
              :to="{name: 'NovelImport'}"
            >
              <ListIcon
                style="color: var(--v-accent-base);width:6px;height:7px;"
                class="mr-1"
              />
              小説サイトバックアップファイルからインポート<br>小説家になろう・カクヨムのバックアップファイルに対応
            </v-btn>
          </div>
        </v-list-item>
        <v-col
          v-if="filterNovels && filterNovels.length==0"
          class="mb-5 px-3 mt-2"
          cols="12"
        >
          <v-card
            class="mx-auto px-0 px-sm-6"
            flat
            height="550"
            style="padding-top:30px;background-color: var(--v-background2-base);"
            width="440"
          >
            <v-img src="../assets/empty2.png" />
            <v-btn
              :to="{name:'NovelsCreate'}"
              color="secondary"
              elevation="0"
              height="60"
              max-height="60"
              style="margin-top:30px;border-radius: 8px;font-size: 17px;font-weight: bold"
              width="100%"
            >
              <v-img
                class="mr-3"
                contain
                max-height="22px"
                max-width="22px"
                src="../assets/file_w.png"
              />
              　新規追加する
              <v-spacer />
              <v-img
                contain
                max-height="22px"
                max-width="22px"
                src="../assets/plus_w.png"
              />
            </v-btn>
            <v-btn
              :to="{name: 'NovelImport'}"
              color="secondary"
              elevation="0"
              height="60"
              max-height="60"
              style="margin-top:30px;border-radius: 8px;font-size: 17px;font-weight: bold"
              width="100%"
            >
              <v-img
                class="mr-3"
                contain
                max-height="22px"
                max-width="22px"
                src="../assets/file_w.png"
              />
              　
              <div style="font-size: 12px;">
                投稿サイトバックアップファイルから<br>
                インポート<br>
                ※現在小説家になろうのみ対応
              </div>
              <v-spacer />
              <v-img
                contain
                max-height="22px"
                max-width="22px"
                src="../assets/plus_w.png"
              />
            </v-btn>
          </v-card>
        </v-col>

        <v-col
          v-if="filterNovels && filterNovels.length>0"
          class=" mb-8  mx-sm-4 mx-0"
          cols="12"
          lg="3"
          md="4"
          sm="6"
          xl="2"
        >
          <v-card
            :to="{name:'NovelsCreate'}"
            class="d-flex flex-column justify-center"
            flat
            :height="listItemHeight"
            style="border-radius: 8px"
          >
            <v-card-text align="center">
              <v-img
                :style="`opacity: ${bgOpacity}`"
                class="ma-8"
                src="../assets/plus.png"
                contain
                :height="listItemHeight"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          v-for="(item) in filterNovels"
          :key="item.id"
          class=" mb-8  mx-sm-4 mx-0"
          cols="12"
          lg="3"
          md="4"
          sm="6"
          xl="2"
        >
          <v-card
            :to="{name:'NovelIndex', params:{novelid:encodeHash(item.id)}}"
            class="d-flex flex-column "
            flat
            :height="listItemHeight"
            style="border-radius: 8px;"
          >
            <!--  <v-img
              :style="`opacity:${bgOpacity};position:absolute;`"
              max-width="232px"
              src="../assets/book.png"
            />-->
            <div
              style="z-index: 1;"
            >
              <v-card-title
                v-if="user.novelFilterTitle"
                class="griditem-title ma-0 pb-2"
              >
                <v-clamp
                  v-if="user.novelFilterTitle"
                  :max-lines="4"
                  autoresize
                >
                  {{ item.name }}
                </v-clamp>
              </v-card-title>
              <div
                v-if="user.novelFilterTitle"
                class="griditem-border mr-4 ml-4 "
              />
              <v-card-text
                v-if=" user.novelFilterUpdate || user.novelFilterCreate || user.novelFilterSite "
                class="pb-0 mb-0 pt-2"
                style="font-size: 13px;"
              >
                <div v-if="user.novelFilterSite">
                  {{ findSiteType(item.targetSite).label }} <span
                    v-if=" findSiteType(item.targetSite).enableimage==true"
                    class="optionItem"
                  >挿絵○</span> <span
                    v-if="createRubiFormat(item.targetSite)"
                    class="optionItem"
                  >{{ createRubiFormat(item.targetSite) }}</span>
                </div>
                <div
                  v-if="user.novelFilterUpdate"
                  class="griditem-content-bold"
                >
                  <ListIcon
                    :style="`color: ${accentColor};width:6px;height:7px;margin-bottom:1px;`"
                    class=" mr-1"
                  />
                  更新日時
                </div>
                <div
                  v-if="user.novelFilterUpdate"
                  class="griditem-content"
                >
                  {{ item.updateDate |dayjs }}
                </div>
                <div
                  v-if="user.novelFilterCreate"
                  class="griditem-content-bold"
                >
                  <ListIcon
                    :style="`color: ${accentColor};width:6px;height:7px;margin-bottom:1px;`"
                    class=" mr-1"
                  />
                  作成日時
                </div>
                <div
                  v-if="user.novelFilterCreate"
                  class="griditem-content"
                >
                  {{ item.createdDate |dayjs }}
                </div>
              </v-card-text>
              <v-spacer />
              <v-card-actions
                class="pr-4 pb-0 pl-0 pt-0"
              >
                <v-spacer />
                <v-btn
                  :color="accentColor"
                  :to="{ name: 'NovelEdit', params: { novelid: encodeHash(item.id) }}"
                  class="pl-4 pr-4"
                  elevation="0"
                  small
                  style="color:#FFFFFF;"
                  tile
                >
                  編集
                </v-btn>

                <v-btn
                  :color="accentColor"
                  class="pl-4 pr-4"
                  elevation="0"
                  outlined
                  small
                  tile
                  @click.prevent="deleteConfirm(item)"
                >
                  削除
                </v-btn>
              </v-card-actions>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  class="text-button-small ma-0 pa-0 pr-2"
                  text
                  x-small
                  @click.prevent="copyItemData=item;copyDialog=true"
                >
                  <ListIcon
                    :style="`color: ${accentColor};width:6px;height:7px`"
                    class="mr-1"
                  />
                  小説をコピー
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>


    <v-dialog
      v-model="filterMenu"
      max-width="400"
    >
      <v-card>
        <v-card-title>一覧表示設定</v-card-title>
        <v-card-text>
          <div>
            <ListIcon
              :style="`color: ${accentColor};width:6px;height:7px`"
              class="mr-1"
            />
            表示フィルタリング
          </div>
          <v-chip
            class="ma-1"
            :color="filterSettingUser.novelFilterTitle ? accentColor:null"
            @click="filterSettingUser.novelFilterTitle = !filterSettingUser.novelFilterTitle"
          >
            タイトル
          </v-chip>
          <v-chip
            class="ma-1"
            :color="filterSettingUser.novelFilterSite ? accentColor:null"
            @click="filterSettingUser.novelFilterSite = !filterSettingUser.novelFilterSite"
          >
            投稿先サイト・ルビタイプ
          </v-chip>
          <v-chip
            class="ma-1"
            :color="filterSettingUser.novelFilterUpdate ? accentColor:null"
            @click="filterSettingUser.novelFilterUpdate = !filterSettingUser.novelFilterUpdate"
          >
            更新日
          </v-chip>
          <v-chip
            class="ma-1"
            :color="filterSettingUser.novelFilterCreate ? accentColor:null"
            @click="filterSettingUser.novelFilterCreate = !filterSettingUser.novelFilterCreate"
          >
            作成日
          </v-chip>

          <!-- <div>
            <ListIcon
              :style="`color: ${accentColor};width:6px;height:7px`"
              class="mr-1"
            />
            グリッド表示の列数 : {{ filterSettingUser.novelGridCount }}
          </div>
          <v-slider
            v-model="filterSettingUser.novelGridCount"
            max="8"
            min="0"
          />-->
        <!--  <div>
            <ListIcon
              :style="`color: ${accentColor};width:6px;height:7px`"
              class="mr-1"
            />
            メニューの短縮表示
          </div>
          <v-switch v-model="filterSettingUser.novelFilterMenu" />-->
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="filterMenu = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="saveFilterSetting"
          >
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          削除確認
        </v-card-title>
        <v-card-text v-if="deleteItemData!=null">
          「{{ deleteItemData.name }}」　を削除してもよろしいですか？
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="deleteDialog = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="deleteItem(deleteItemData)"
          >
            削除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="copyDialog"
      max-width="290"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          確認
        </v-card-title>
        <v-card-text v-if="copyItemData!=null">
          「{{ copyItemData.name }}」　のコピーを作成します。<br>よろしいですか？
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            :disabled="copyProgress"
            @click="copyDialog = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="copyProgress"
            @click="copyNovel(copyItemData)"
          >
            コピーする
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import firebase from "firebase/app"
import {mapState} from "vuex";
import dayjs from 'dayjs';
import VClamp from 'vue-clamp'
import ListIcon from "@/component/svg/ListIcon";
import constants from "@/const"
import config from "@/const"
import SortTypeSelect from "@/component/SortTypeSelect";
import sortByText from '../component/sortByText'
import axios from "axios";
import clonedeep from 'lodash.clonedeep';
export default {
  name: "NovelsIndexVue",
  ...mapState({
    user: state => state.userModule.user,
    novels: state => state.NovelListModule.NovelList
  }),
  components: {
    SortTypeSelect,
    VClamp,
    ListIcon
  },
  filters: {
    dayjs: function (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm');
    }
  },
  data() {
    return {
      deleteDialog: false,
      deleteItemData: null,
      accentColor: null,
      backgroundColor: null,
      bgOpacity: null,
      siteTypes: constants.SITE_TYPE,
      sortDialog: null,
      sortItems: config.NOVEL_SORT_TYPE,
      copyItemData: null,
      copyDialog: false,
      copyProgress: false,
      filterMenu:false,
      filterSettingUser: {}
    }
  },

  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    this.backgroundColor = this.$vuetify.theme.dark ? 'black' :
        'white'
    this.bgOpacity = this.$vuetify.theme.dark ? 0.1 : 1
  },
  computed: {
    ...mapState({
      user: state => state.userModule.user,
      novels: state => state.NovelListModule.NovelList,
      sortType: state => state.userModule.user.novelSort,
    }),
    filterNovels: function () {
      return this.novels
    },
    listItemHeight:function (){
      let listHeight=0
      if(this.user.novelFilterTitle){
        listHeight+=60
      }
      if(this.user.novelFilterSite){
        listHeight+=60
      }
      if(this.user.novelFilterUpdate){
        listHeight+=50
      }
      if(this.user.novelFilterCreate){
        listHeight+=50
      }
        listHeight+=60
      return listHeight
    }
  },
  watch: {
    user:{
      handler:function (){
        this.filterSettingUser=clonedeep(this.user);
      },immediate: true
    },
    sortType: {
      handler: function () {
        this.sort()
      }, immediate: false
    }
  },
  methods: {
    saveFilterSetting(){
      this.$store.commit("userModule/setUser",this.filterSettingUser)
      this.$store.dispatch("userModule/saveSetting")
      this.filterMenu=false
    },
    sort() {
      this.novels.sort((a, b) => {
        switch (this.sortType) {
          case 0:
            return sortByText.sortNum(b.updateDate,a.updateDate)
          case 1:
            return sortByText.sortNum(a.updateDate,b.updateDate)
          case 2:
            return sortByText.sortNum(b.createdDate,a.createdDate)
          case 3:
            return sortByText.sortNum(a.createdDate,b.createdDate)
          case 4: {
            if (sortByText.sort(a.name, b.name) != 0) {
              return sortByText.sort(a.name, b.name) * -1
            }
            return sortByText.sortNum(b.createdDate,a.createdDate)
          }
          case 5: {
            if (sortByText.sort(a.name, b.name) != 0) {
              return sortByText.sort(a.name, b.name)
            }
            return sortByText.sortNum(a.createdDate,b.createdDate)
          }
        }
        return 0
      })
    },
    selectSort(sort) {
      this.$store.dispatch("userModule/updateParams", {"novelSort": sort})
      this.$store.dispatch("userModule/saveSetting")
      this.sortDialog = false

    },
    encodeHash: function (id) {
      return constants.HASH_IDS.encode(id)
    },
    findSiteType(index) {
      return constants.findSiteType(index)
    },
    createRubiFormat(index) {
      if (constants.findSiteType(index).rubiFormat) {
        return "" + constants.findSiteType(index).rubiFormat.prefix + "ルビ" + constants.findSiteType(index).rubiFormat.middle + "ルビ" + constants.findSiteType(index).rubiFormat.suffix + ""
      } else {
        return ""
      }
    },
    loguout() {
      firebase.auth().signOut();
    },
    async copyNovel(itemData) {
      this.copyProgress = true;
      try {
        const user = firebase.auth().currentUser
        const token = await user.getIdToken(false)
        const ret = await axios.post(config.API_URL + "auth/copyNovel", itemData, {
          headers: {"X-Firebase-Auth": token, "fromWeb": false},
        })
        await this.$store.dispatch("NovelListModule/getNovels")
      } catch (e) {
        alert("保存中にエラーが発生しました。")
      }
      this.copyProgress = false;
      this.copyDialog = false;
    },
    // 削除確認ダイアログ表示を追加
    deleteConfirm(deleteItemData) {
      this.deleteItemData = deleteItemData;
      this.deleteDialog = true;
    },
    // 削除実行
    deleteItem(deleteItemData) {
      this.$store.dispatch("NovelListModule/delete", {
        item: deleteItemData,
      }).catch(reason => {
        alert("削除中にエラーが発生しました")
      });
      this.deleteDialog = false;
    },
  },

}
</script>

<style>

.griditem-title {
  font-size: 15px;
  color: var(--v-textcolor-base) !important;
  line-height: 140%;
  font-weight: bold;
}

.griditem-content-bold {
  font-size: 13px;
  font-weight: bold;
  color: var(--v-textcolor-base) !important;
}

.griditem-content {
  font-size: 13px;
  color: var(--v-textcolor-base) !important;
}

.griditem-border {
  background-color: var(--v-bordercolor-base) !important;
  height: 2px;
}

.optionItem {
  margin-left: 6px;
  padding: 2px;
  font-size: 11px;
  letter-spacing: 2px;
  background-color: #7D7D7D;
  color: #FFFFFF;
}
.text-button-small {
  font-size: 11px;
  color: var(--v-textcolor-base) !important;
}
.novel-card{
  background-image: url(~@/assets/book.png);
}
</style>
